import {CdFrequencyPeriod} from '../../../interfaces/care/cd-care-plan/cd-frequency-period';
import {OpPeriod} from '../../../enums/operating-plan/op-period';
import {OpPeriodFactory} from '../../operating-plan/op-period-factory';

/**
 *
 */
export class CdFrequencyPeriodFactory {
  public static fromObject(cdFrequencyPeriod: any): CdFrequencyPeriod {
    return new class implements CdFrequencyPeriod {
      cdFrequencyId: number = cdFrequencyPeriod.cd_frequency_id;
      id: number = cdFrequencyPeriod.id;
      opPeriodId: number = cdFrequencyPeriod.op_period_id;
      opPeriod: OpPeriod =
        cdFrequencyPeriod.op_period ? OpPeriodFactory.fromObject(cdFrequencyPeriod.op_period) : null;
      userId: number = cdFrequencyPeriod.user_id;
    };
  }

  public static new(opPeriodId: number = null, opPeriod: OpPeriod = null): CdFrequencyPeriod {
    return new class implements CdFrequencyPeriod {
      cdFrequencyId: number = null;
      id: number = null;
      opPeriodId: number = opPeriodId;
      opPeriod: OpPeriod = opPeriod;
      userId: number = null;
    };
  }

  /**
   *
   * @param cdFrequencyPeriods
   */
  public static fromArray(cdFrequencyPeriods: any[]): CdFrequencyPeriod[] {
    return cdFrequencyPeriods.map(_cdFrequencyPeriod => CdFrequencyPeriodFactory.fromObject(_cdFrequencyPeriod));
  }

  public static toRemote(cdFrequencyPeriod: CdFrequencyPeriod): any {
    return {
      op_period_id: cdFrequencyPeriod.opPeriodId,
      id: cdFrequencyPeriod.id,
      c_frequency_id: cdFrequencyPeriod.cdFrequencyId
    };
  }

  public static toArray(cdFrequencyPeriods: CdFrequencyPeriod[]): any[] {
    return cdFrequencyPeriods.map(_cdFrequencyPeriod => CdFrequencyPeriodFactory.toRemote(_cdFrequencyPeriod));
  }

}
